import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { styled, useTheme, alpha } from '@mui/material/styles';
import { Box, Stack, Drawer, Grid, Typography } from '@mui/material';
// hooks
import useCollapseDrawer from 'hooks/useCollapseDrawer';
import useNavConfig from 'hooks/useNavConfig';
import useAuth from 'hooks/useAuth';
import useIsMobile from 'hooks/useIsMobile';
// utils
import cssStyles from 'utils/cssStyles';
import { printLAstDate } from 'utils/formatTime';
// redux
import { useDispatch } from 'redux/store';
import { onSaveFilter } from 'redux/slices/Patient';

// config
import { HEADER, NAVBAR } from 'config';
// components
import Scrollbar from 'components/Scrollbar';
import { NavSectionVertical } from 'components/nav-section';

// routes
import { PATH_DASHBOARD } from 'routes/paths';

import CollapseButton from './CollapseButton';
import LogOutButton from './LogOutButton';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter
    })
  }
}));

const CollapseStyle = styled(Stack)(({ theme }) => ({
  height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
  marginBottom: 20,
  paddingLeft: theme.spacing(1)
}));

// ----------------------------------------------------------------------

NavbarVertical.propTypes = {

};

export default function NavbarVertical() {
  const theme = useTheme();
  const navConfig = useNavConfig();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { user: { usercode, nom, prenom, datederniereconsult }, profile: { label }, logout } = useAuth();
  const navigate = useNavigate();
  const { isCollapse, collapseClick, collapseHover, onToggleCollapse } =
    useCollapseDrawer();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isCollapse) {
      onToggleCollapse();
    }
    if (isCollapse && pathname === PATH_DASHBOARD.home.app && !isMobile) {
      onToggleCollapse();

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);


  const handleLogout = async () => {
    try {
      await dispatch(onSaveFilter(null));
      await logout(usercode);
      navigate('/');
    } catch (error) {
      console.error(error);
    }
  };
  const renderContent = (
    <Scrollbar
      sx={{
        backgroundImage: `linear-gradient(to bottom, ${alpha(theme.palette.primary.main, 1)} 70%, ${alpha(theme.palette.primary.main, 1)} 100%)`,
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' }
      }}
    >
      <Stack
        spacing={3}
        sx={{
          flexShrink: 0,
          ...(isCollapse && { alignItems: 'center' })
        }}
      >
        <CollapseStyle direction="row" justifyContent="center">
          <Grid container spacing={0}>
            <Grid item alignSelf="center" xs={12} md={2} >
              <CollapseButton onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />
            </Grid>
            <Grid item alignSelf="center" textAlign="center" xs={12} md={10}>
              <Typography
                variant="h6"
                sx={{ color: 'white', textTransform: 'uppercase' }} >{nom} {prenom}</Typography>

              <Typography
                variant="body2"
                sx={{ color: 'white' }} >{label}</Typography>

              <Typography
                variant="caption"
                sx={{ color: 'white' }} >Dernière connexion : {printLAstDate(datederniereconsult)}</Typography>
            </Grid>
          </Grid>


        </CollapseStyle>

      </Stack>
      <LogOutButton onLogOut={handleLogout} />
      <NavSectionVertical navConfig={navConfig} isCollapse={isCollapse} />
      <Stack sx={{ p: 5, backgroundColor: 'white', height: 'inherit', display: 'flex', justifyContent: 'flex-start' }} justifyContent="center">
        <Box className="wrapper_logo_compact" />
      </Stack>

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar >
  );

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH
        },
        ...(collapseClick && {
          position: 'absolute'
        })
      }}
    >
      <Drawer
        open
        variant="persistent"
        // onMouseEnter={onHoverEnter}
        // onMouseLeave={onHoverLeave}
        PaperProps={{
          sx: {
            width: { lg: NAVBAR.DASHBOARD_WIDTH, sm: NAVBAR.DASHBOARD_WIDTH - 60 },
            borderRightStyle: 'dashed',
            bgcolor: 'background.default',
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.standard
              }),
            ...(isCollapse && {
              width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH
            }),
            ...(collapseHover && {
              ...cssStyles(theme).bgBlur(),
              boxShadow: (theme) => theme.customShadows.z24
            })
          }
        }}
      >
        {renderContent}
      </Drawer>
    </RootStyle>
  );
}
